import { Component, OnInit } from "@angular/core";
import { AnimationItem } from 'lottie-web';
import { AnimationOptions } from 'ngx-lottie';
@Component({
  selector: "app-landing-page",
  templateUrl: "./landing-page.component.html",
  styleUrls: ["./landing-page.component.scss"],
})
export class LandingPageComponent implements OnInit {
  path: string = 'assets/whats_new.json';
  text: string = '';

  options: AnimationOptions = {
    path: this.path, // Replace with your JSON animation path
  };

  animationCreated(animationItem: AnimationItem): void {
    console.log(animationItem);
  }
  constructor() {}

  ngOnInit(): void {
    
  }
}
